/**
 * WHO-5688. Pro Buyer step 2: the buyer-side landing page and application.
 *
 * Naming (Evelien, 17 Sep 2026): customer-facing copy says "Pro Buyer" in
 * every locale, untranslated. Copy lives in the `pro-buyer-application`
 * Lokalise namespace; the step 1 `pro-buyer` namespace is the seller page's.
 */

export const PRO_BUYER_ROUTE = "/pro-buyer";

/** Anchor of the application block; the hero button scrolls to it. */
export const PRO_BUYER_APPLY_ANCHOR = "aanvragen";

/**
 * Where login and signup return to. No `#aanvragen`: the login page encodes
 * the hash into the path (`/nl/pro-buyer%23aanvragen`, a 404; Evelien, stap 2
 * blocker 23 Sep). The page scrolls to the block itself when the buttons left
 * `PRO_BUYER_SCROLL_FLAG` in sessionStorage.
 */
export const PRO_BUYER_APPLY_RETURN_URL = PRO_BUYER_ROUTE;

/** sessionStorage key set by Inloggen / Account aanmaken, read once on return. */
export const PRO_BUYER_SCROLL_FLAG = "pro-buyer-scroll-to-apply";

/** The brand name, identical in every locale, used by the menu and footer. */
export const PRO_BUYER_NAV_LABEL = "Pro Buyer";

/** Same limits as the gateway mutation `submitProBuyerApplication`. */
export const PRO_BUYER_FIELD_MAX_LENGTH = {
  companyName: 120,
  registrationNumber: 40,
  website: 200,
} as const;

export type ProBuyerApplicationField = keyof typeof PRO_BUYER_FIELD_MAX_LENGTH;

export const PRO_BUYER_APPLICATION_FIELDS: ProBuyerApplicationField[] = [
  "companyName",
  "registrationNumber",
  "website",
];

/** Price example in "Wat je krijgt": an asking price and a typical discount. */
export const PRO_BUYER_EXAMPLE_PRICE = 1000;
export const PRO_BUYER_EXAMPLE_PCT = 15;

/** Landing-page example only; checkout prices come from the gateway. Same
 * rule as the gateway's computeTradePrice: round down to whole euros. */
export const PRO_BUYER_EXAMPLE_TRADE_PRICE = Math.floor(
  (PRO_BUYER_EXAMPLE_PRICE * (100 - PRO_BUYER_EXAMPLE_PCT)) / 100
);
